export enum ProductPlan {
  STANDARD = 'STANDARD',
  PRO = 'PRO',
  ENTERPRISE = 'ENTERPRISE',
}

interface UnexpiredSubscribedPlan {
  id?: ProductPlan;
  canMakeNextPayment: false;
  addons?: PlanAddon[];
  trialAddons?: PlanAddon[];
  piiSettings?: {
    textPolicy?: 'SEND' | 'REJECT' | 'MASK';
    mediaPolicy?: 'SEND' | 'REJECT' | 'MASK';
    maskApiConfig?: {
      media?: {
        url: string;
        authorization?: string;
      };
      text?: {
        url: string;
        authorization?: string;
      };
    };
  };
}

interface ExpiredSubscribedPlan {
  id: ProductPlan;
  numUsers: number;
  displayName: string;
  currencyCode: string;
  canMakeNextPayment: true;
  renewalDate: string;
  willPaymentAutoRenew: boolean;
  customPricing: boolean;
  status: 'active' | 'cancelled' | 'expired' | 'payment_progress' | 'expired_grace';
  price: [
    {
      id: string;
      amount: number;
      unit: 'month' | 'year';
    }
  ];
  function?: {
    type: FunctionTypes;
  };
  addons: PlanAddon[];
  trialAddons: PlanAddon[];
  piiSettings?: {
    textPolicy?: 'SEND' | 'REJECT' | 'MASK';
    mediaPolicy?: 'SEND' | 'REJECT' | 'MASK';
    maskApiConfig?: {
      media?: {
        url: string;
        authorization?: string;
      };
      text?: {
        url: string;
        authorization?: string;
      };
    };
  };
}

export interface PlanAddon {
  addonId: string;
  startDate: string;
  endDate: string;
}

export enum PlanAddonTypes {
  Tally = 'Tally-Integration',
  ActivityLogs = 'Activity-Logs',
  ComplexBot = 'Complex-Bot',
  WooCommerce = 'Woo-Commerce',
  SlaAddon = 'SLA-Addon',
  AiBot = 'AI-Bot',
  EnterpriseAnalytics = 'Enterprise-Analytics',
  Salesforce = 'Salesforce',
  LeadSquaredIntegration = 'LeadSquared-Integration-Addon',
  CapiSupportAddon = 'Capi-Support-Addon',
  WaVoiceAddon = 'WA-CALL', // depricated
  CallingLicense = 'Calling-License',
  IP_RESTRICTIONS = 'IP_RESTRICTIONS',
  ZOHO_CRM = 'Zoho-CRM-Integration-Addon',
  EnterpriseSecurity = 'Enterprise-Security',
  WA_Groups = 'WA-Groups',
}

export enum FunctionTypes {
  CONTACT_SUPPORT = 'CONTACT_SUPPORT',
}

export enum PaymentStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  FAILED = 'FAILED',
  RECEIVED = 'RECEIVED',
}

export type SubscribedPlan = ExpiredSubscribedPlan | UnexpiredSubscribedPlan;

export interface GetSubscribedPlanResponse {
  subscribedPlan: SubscribedPlan;
}

export interface GetPlanStatusResponse {
  emailVerificationRequired: boolean;
  planPaymentStatus?: {
    id: string;
    currencyCode: string;
    name: string;
    price: [
      {
        id: string;
        amount: number;
        unit: 'month' | 'year';
      }
    ];
    paymentStatus: PaymentStatus;
  };
  planSubscribed?: SubscribedPlan;
}
